import { render, staticRenderFns } from "./OverviewAddress.vue?vue&type=template&id=47142012&scoped=true&"
import script from "./OverviewAddress.vue?vue&type=script&lang=js&"
export * from "./OverviewAddress.vue?vue&type=script&lang=js&"
import style0 from "./OverviewAddress.vue?vue&type=style&index=0&id=47142012&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47142012",
  null
  
)

export default component.exports